export enum ErrorTypes{
    TASAS_ACTUALIZADAS = 'TASAS_ACTUALIZADAS',
    ERROR_CREANDO = 'ERROR_CREANDO_TRANSACCION'
}